import dayjs from "dayjs";
import { createElement } from "react";
import { ExpertsTableColumn, FiltersType, MenuItemProps, PartnersFilterType, ReferenceDetailType, ReferencesFilterType, TableColDefinition } from "../types/dataTypes";
import { Add, DocumentScanner, FormatListBulleted, Brush } from "@mui/icons-material";
import { GridColDef, GridRenderCellParams } from "@mui/x-data-grid";
import ReferenceExpertActionsCell from "../components/references/ReferenceExpertActionsCell";
import ReferencePartnerActionsCell from "../components/references/ReferencePartnerActionsCell";

export const PAGE_LIMIT = 25;
export const PAGE_TITLE = "Integration Internal Database App";

export const GLOBAL_SIZES = { HEADER: 50 }

export const CSS = { MAX_WIDTH: "640px" }

export const initialFormData: ReferenceDetailType = {
    ProjectID: 0,
    LangVerID: 0,
    ProjectNo: '',
    FocusOn: '',
    ProjectTitle: '',
    ProjectTitle_short: '',
    Country: '',
    Location: '',
    Region: '',
    short: '',
    FieldOfService: '',
    country_homepage: '',
    OriginOfFunding: '',
    StartDay: '',
    StartDate: '',
    EndDay: '',
    CompletionDate: '',
    ProjectValue: '',
    ProportionLegalEntity: '',
    NoOfStaff: '',
    NoOfPersonMonth: '',
    Personnel: '',
    Personnel_EU_EOI: '',
    AssociatedFirms: '',
    Consortium: '',
    Lead: false,
    SeniorStaff: '',
    ProjectResults: '',
    ProjectBackground: '',
    ProjectObjectives: '',
    ProjectActivities: '',
    ServicesProvided: '',
    ImplementationFeatures: '',
    ProjectDescription_short: '',
    extrashort_GTZ_PQ: '',
    KeyWords: '',
    Picture: '',
    Category: '',
    zuständig: '',
    ClientContact: '',
    ProjectValueEuro: '',
    ProjectValueDollar: '',
    Folder: '',
    NewRef: false,
    INTEE: false,
    CoP: false,
    variant_name: '',
    variant_description: '',
    ClientID: 0,
    Homepage: false,
    Bemerkungen: '',
    ConstructionServicesEUR: 0,
    ConstructionServicesDollar: 0,
    ProjectDescription_short_german: '',
    address: '',
    NoOfPersonMonthsByAssociatedFirms: '',
    Textvariante1: '',
    Textvariante2: '',
    Textvariante3: '',
    NoOfPersonMonthINT: '',
    ProjectDescription_detailed: '',
    extrashort_GTZ_PQ_german: '',
  };

  // Initial state for filters
export const initialFiltersReferences: ReferencesFilterType = {
    completionDate: dayjs().subtract(5, 'year'),
    countries: [],
    selectedCompany: 'both',
    projectValueEuro: 50000,
    fieldsOfServices: [],
    refNumTitles: [],
    fullTextProjectNumberList: [],
    printSelectionList: [],
  };

  export const MetaDataReferences = [
    {database: 'references', tables:['FieldOfService','Client']},
    {database: 'experts', tables:['language','region','donor']},
  ]

  export const WorkExperienceOptions = [
    "0-5 years",
    "5-10 years",
    "10-15 years",
    "15-20 years",
    "> 20 years",
  ]

  export const GenderOptions = [
    "Woman",
    "Man",
    "Non-binary",
    "Unknown",
  ]

  export const ReferencesTableDataColumns = ["ProjectNo", "ProjectTitle", "Client", "Country", "ProjectValueEuro", "StartDate", "CompletionDate",
    "INTEE", "Homepage", "FieldOfService"]


  export const initialFiltersExperts: FiltersType = {
  names: [],
  languages: [],
  regions: [],
  donors: [],
  keywords: [],
  fulltext: [],
  nationalities: [],
  ageRange: [],
  positions: [],
  integrationProject: '',
  referenceId: '',
};

export const getMenuItems = (
  setOpenAddDialoge: (action: 'open' | 'close') => void,
  handleManageMetaDataDialoge: (action: 'open' | 'close') => void,
  handleCvTemplateDialoge: () => void,
  handleCvFormaterDialoge: () => void
): MenuItemProps[] => [
  {
    name: 'Add Expert',
    IconButton: Add,
    onClickFunction: () => setOpenAddDialoge('open'),
    adminOnly: false,
  },
  {
    name: 'Manage Meta Data',
    IconButton: FormatListBulleted,
    onClickFunction: () => handleManageMetaDataDialoge('open'),
    adminOnly: true,
  },
  {
    name: 'CV Evaluation Engine',
    IconButton: DocumentScanner,
    onClickFunction: () => handleCvTemplateDialoge(),
    adminOnly: true,
  },
  {
    name: 'CV Formater',
    IconButton: Brush,
    onClickFunction: () => handleCvFormaterDialoge(),
    adminOnly: true,
  },
];

// Update the handleCvTemplateDialoge function to open a new tab
export const handleCvTemplateDialoge = () => {
  window.open(`${window.location.origin}/cvevaluator`, '_blank');
};

export const handleCvFormaterDialoge = () => {
  window.open(`${window.location.origin}/cvformater`, '_blank');
};

export const expertsTableColumns: ExpertsTableColumn[] = [
  { key: "name", label: "Name", width: "10px", sortable: true },
  { key: "keywords", label: "Experience", width: "100px", sortable: true },
  { key: "Age", label: "Age", width: "10px", sortable: true },
  { key: "years_of_work_experience", label: "Years of Experience", width: "10px", sortable: true },
  { key: "nationality", label: "Nationality", width: "10px", sortable: true },
  { key: "languages", label: "Languages", width: "10px", sortable: true },
  { key: "regions", label: "Regions", width: "10px", sortable: true },
  { key: "donors", label: "Donors", width: "10px", sortable: true },
  { key: "email", label: "Email", width: "10px", sortable: true },
  { key: "cvYear", label: "latest CV Year", width: "10px", sortable: true },
  { key: "consent", label: "Consent", width: "10px", sortable: true, render: (item) => (item.consent ? "Yes" : "No") },
];

  export const initialFiltersPartners: PartnersFilterType = {
    name: [],
    countries: [],
    fos: [], 
  };

export const partnerTableDefinition: TableColDefinition[] = [
  { key: 'name', label: 'Name', width: '100px', sortable: true, isList: false, openDetails: true},
  { key: 'city', label: 'Headquarter', width: '100px', sortable: true, isList: false },
  { key: 'fos', label: 'Field of Services', width: '100px', sortable: false, isList: true },
  { key: 'latest_collab_project_number', label: 'Last Collab #', width: '100px', sortable: true, isList: false },
  { key: 'latest_collab', label: 'Last Collab Title', width: '100px', sortable: true, isList: false },
  { key: 'latest_collab_date', label: 'Last Collab Date', width: '100px', sortable: true, isList: false },
  { key: 'number_of_collaborations', label: '# Total Collab', width: '100px', sortable: true, isList: false },
  { key: 'countries', label: 'Countries Operating in', width: '100px', sortable: false, isList: true},
]

export const partnerContactsGridDefinition: GridColDef[] = [
  { field: 'id', headerName: 'ID', width: 70, editable: false}, // Hidden ID field
  { field: 'first_name', headerName: 'First Name', flex:1,  editable: true },
  { field: 'last_name', headerName: 'Last Name', flex:1, editable: true },
  { field: 'email', headerName: 'Email', flex:1,  editable: true },  
  { field: 'phone', headerName: 'Phone', flex:1,  editable: true },
  { field: 'position', headerName: 'Position', flex:1,  editable: true },
  { field: 'comment', headerName: 'Comment', flex:1,  editable: true },
];  

export const partnerCollabHistoryGridDefinition: GridColDef[] = [
  { field: 'id', headerName: 'ID', width: 70, editable: false}, // Hidden ID field
  { field: 'project_number', headerName: 'Project Number',flex:1, editable: false},
  { field: 'project_title', headerName: 'Title',flex:2,  editable: false },
  { field: 'completion_date', headerName: 'Completion Date',flex:1, editable: false },  
  { field: 'lead', headerName: 'INT-EE Lead',flex:1, editable: false },
  { field: 'input_share_partner', headerName: 'Input Share By Partner',flex:1, editable: true },
  { field: 'profit_share_partner', headerName: 'Profit Share By Partner',flex:1,  editable: true },
  { field: 'comment', headerName: 'Comment',flex:2,  editable: true },
];  

export const partnerExpertGridDefinition: GridColDef[] = [
  { field: 'id', headerName: 'ID', width: 70, editable: false}, // Hidden ID field
  { field: 'name', headerName: 'Name',flex:1,  editable: true },
  { field: 'position', headerName: 'Last Position',flex:1,  editable: true },
  { field: 'rate', headerName: 'Last Rate',flex:1,  editable: true },
  { field: 'comment', headerName: 'Comment',flex:1, editable: true },
];

export const referenceExpertGridDefinition: GridColDef[] = [
  { field: 'id', headerName: 'ID', width: 70, editable: false }, // bridge_experts_references.ID, hidden-ish
  { field: 'name', headerName: 'Expert', flex: 1.2, editable: false },
  { field: 'position', headerName: 'Position', flex: 1, editable: true },
  {
    field: 'ratePerDay', headerName: 'Rate / Day', flex: 1, editable: true, type: 'number',
    description: 'Selling rate in EUR per day for this expert on this reference.',
  },
  {
    field: 'daysWorked', headerName: 'Days Worked', flex: 1, editable: true, type: 'number',
    description: 'Number of days worked on this reference - either an estimate, or the actual days implemented, as the sum of home-office and local (in-country) days.',
  },
  {
    field: 'source', headerName: 'Source', flex: 1, editable: true, type: 'singleSelect',
    valueOptions: ['Integration', 'Partner'],
    description: 'Whether the expert was engaged directly via Integration, or via a partner organization, for this assignment.',
  },
  {
    // Edited via the dependent "Partner" select in the add/edit dialog (only for source = Partner);
    // the options are the partners linked to this reference.
    field: 'partnerID', headerName: 'Partner (via)', flex: 1.2, editable: false,
    valueGetter: (params: any) => (params.row?.source === 'Partner' ? (params.row.partnerName ?? '') : ''),
    description: 'The partner firm the expert came through (only for source Partner). Must be linked to this reference first.',
  },
  {
    field: 'actions',
    headerName: 'Links',
    width: 100,
    editable: false,
    sortable: false,
    filterable: false,
    // Non-editable action icons (view expert detail page / view latest CV), mirroring
    // ExpertsTable.tsx's own "View Details" and "View Latest CV" row actions. The 'actions'
    // field name is what EditableDataGrid already special-cases to exclude from its
    // add/edit row dialog, so this column never shows up as an editable text field there.
    renderCell: (params: GridRenderCellParams) => createElement(ReferenceExpertActionsCell, { row: params.row }),
  },
];

// Grid definition for the Reference "Partners" tab - deliberately minimal (just the
// partner's name plus a link-out action), since input_share_partner/profit_share_partner/
// comment stay editable only from the Partner-side collaboration form, not here.
export const referencePartnerGridDefinition: GridColDef[] = [
  { field: 'id', headerName: 'ID', width: 70, editable: false }, // partnerID
  { field: 'name', headerName: 'Partner', flex: 1.2, editable: false },
  {
    field: 'actions',
    headerName: 'Links',
    width: 100,
    editable: false,
    sortable: false,
    filterable: false,
    // Non-editable action icon (view partner detail page), mirroring
    // referenceExpertGridDefinition's own 'actions' column. The 'actions' field name is
    // what EditableDataGrid already special-cases to exclude from its add/edit row dialog.
    renderCell: (params: GridRenderCellParams) => createElement(ReferencePartnerActionsCell, { row: params.row }),
  },
];